<script>
import { mapActions } from 'vuex';
export default {
    data: () => ({
        errors : {
            "email": {
                "active": false,
                "message": ""
            },
            "password": {
                "active": false,
                "message": ""
            },
            "code": {
                "active": false,
                "message": ""
            },
        },
        email: "",
        code : "",
        password : "",
        loading: false,
        error: '',
        step: 1,
        recovered: false
    }),
    methods: {
        handleSubmit() {
            if(this.step == 2 && this.code === "") {
                this.errors.code.active = true;
                this.errors.code.message = "La contraseña es un campo necesario";
                return;
            }

            if(this.step == 2 && this.password === "") {
                this.errors.password.active = true;
                this.errors.password.message = "La contraseña es un campo necesario";
                return;
            }

            this.errors.email.active = false;
            this.errors.code.active = false;
            this.errors.password.active = false;

            if (this.step == 1) {
                return this.attemptRecoverRequest();
            }

            this.attemptRecover();
        },
        async attemptRecoverRequest() {
            this.loading = true;
            this.error = '';

            try {
                let {data} = await axios.post('/recover-request',{
                    email : this.email
                });

                console.log(data);
                this.step = 2;
            } catch (error) {
                console.error(error);
                this.error = (typeof error.response.data.message != 'undefined') && error.response.data.message
                    ? error.response.data.message
                    : 'Ha ocurrido un error inesperado. Por favor intente nuevamente.';
            } finally {
                this.loading = false;
            }
        },
        async attemptRecover() {
            this.loading = true;
            this.error = '';

            try {
                let {data} = await axios.post('/recover',{
                    email : this.email,
                    code : this.code,
                    new_password : this.password
                });

                console.log(data);
                this.recovered = true;

                setTimeout(function(){
                     location.reload();
                }, 1500);
            } catch (error) {
                console.error(error);
                this.error = (typeof error.response.data.message != 'undefined') && error.response.data.message
                    ? error.response.data.message
                    : 'Ha ocurrido un error inesperado. Por favor intente nuevamente.';
            } finally {
                this.loading = false;
            }
        },
        ...mapActions(['getAuth']),
    }
}
</script>

<template>
    <div class="lightbox wrapper__form__auth bg-white flex flex-column sm:flex-row justify-content-between rounded-6 mb-4 sm:mb-10">
        <div class="flex-a px-4 py-6 md:px-12 md:pt-8 md:pb-15 w-100 mb-5 sm:mb-0">
            <img class="auth_logo mb-8" src="/assets/images/layout/AD_Logo/PNG/AutoDeal_Logo_Digital.png" alt="AutoDeal">
            <p class="tx-26 tx-grey-1 mb-7">
                Recupera tu cuenta.
            </p>
            <form @submit.prevent="handleSubmit()">
                <div class="form-group mb-5">
                    <label class="form-label form-label--auth">
                        INDICA TU EMAIL
                    </label>
                    <div class="relative">
                        <input class="form-input form-input--auth" type="email" required v-model="email" :class="{ error: errors.email.active }" :disabled="step == 2">
                        <span class="label_error">incorrecto</span>
                    </div>
                </div>
                <div class="form-group mb-5" v-show="step == 2">
                    <label class="form-label form-label--auth">
                        CÓDIGO
                    </label>
                    <div class="relative">
                        <input class="form-input form-input--auth" type="text" v-model="code" :class="{ error: errors.code.active }" maxlength="4" minlength="4" :disabled="recovered">
                        <span class="label_error">incorrecto</span>
                    </div>
                </div>
                <div class="form-group mb-5" v-show="step == 2">
                    <label class="form-label form-label--auth">
                        PASSWORD
                    </label>
                    <div class="form-inner">
                        <div class="form-helper form-helper--auth">
                            <img class="auth_icon_eye" src="/assets/images/helpers/eye-regular.svg" alt="">
                        </div>
                        <input class="form-input form-input--auth" type="password" v-model="password" :class="{ error: errors.password.active }" :disabled="recovered">
                        <span class="label_error">incorrecto</span>
                    </div>
                </div>
                <div class="tx-12 tx-grey-1 underline flex justify-content-between mb-7">
                    <a @click="$emit('login')">
                        Cancelar
                    </a>
                </div>

                <div v-if="error" class="alert alert--warning p-2 fs-12 mb-4">
                    {{ error }}
                </div>

                <div v-if="step == 2 && !recovered && !loading" class="alert alert--success p-2 fs-12 mb-4">
                    Se ha enviado un código de recuperación al email indicado.
                </div>

                <div v-if="recovered" class="alert alert--success p-2 fs-12 mb-4">
                    Su cuenta ha sido recuperada. Iniciando sesión...
                </div>

                <div v-if="step == 1">
                    <input class="btn btn--pink btn--submit-auth tx-14 weight-500 w-full" type="submit" value="Enviando, espere..." disabled v-if="loading">
                    <input class="btn btn--pink btn--submit-auth tx-14 weight-500 w-full" type="submit" value="Siguiente" v-else>
                </div>
                <div v-else>
                    <input class="btn btn--pink btn--submit-auth tx-14 weight-500 w-full" type="submit" value="Recuperando cuenta, espere..." disabled v-if="loading">
                    <input class="btn btn--pink btn--submit-auth tx-14 weight-500 w-full" type="submit" value="Recuperar cuenta" v-else>
                </div>
            </form>
        </div>
        <div class="render_bg_auth hidden sm:flex bg-cover bg-no-repeat bg-center align-items-end flex-none rounded-tr-4 rounded-br-4 p-4 md:px-10 md:py-5" style="background-image:url('/assets/images/layout/bg-auth.jpg');">
            <!-- RENDER BG -->
        </div>
    </div>
</template>
